/* eslint-disable react/require-default-props */
import React from 'react';
import createTrack from 'services/actions/tracker_actions';

interface MapLinkProps {
  address: string;
  source: string;
}

const MapLink = (props: MapLinkProps) => {
  const { address, source = 'biddings' } = props;

  return (
    <button
      type="button"
      className="btn btn-link text-left btn-sm p-0 ml-2"
      onClick={(event) => {
        event.preventDefault();
        createTrack('Card - Clicou no endereço', { fonte: source });
        window.open(`https://www.google.com.br/maps/place/${address}`, '_blank');
      }}
    >
      <i className="material-icons bidding-info-icon">location_on</i>
    </button>
  );
};

export default MapLink;
